import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { VISITS_SUB_PATH } from 'shared/consts';

export const VisitsRedirect: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(VISITS_SUB_PATH, { replace: true });
  }, [navigate]);

  return null;
};
